import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { Icon as r } from "../../atoms/Icon/Icon.mjs";
import { Text as n } from "../../atoms/Text/Text.mjs";
import { cn as o } from "../../../utils/utils.mjs";
function c({ className: t }) {
  return /* @__PURE__ */ i("div", { className: o("size-full flex flex-col gap-3 justify-center items-center", t), children: [
    /* @__PURE__ */ e(r, { name: "loadingRing", width: 24, height: 24, className: "animate-spin [&_path]:stroke-blue-500" }),
    /* @__PURE__ */ e(n, { fontWeight: "regular", fontSize: "xs", children: "Uploading..." })
  ] });
}
export {
  c as LoadingState
};
